import { Carousel } from './Carousel';
import { VideoCard } from '@features/dashboard/widgets/videos/components/VideoCard';
import { MediaContent } from '../types/types';
import { useScreenSize } from '@hooks/useScreenSize';
import { CarouselCard } from './CarouselCard';

export const VideoCarousel = ({
  videos,
  onVideoClick,
  selectedVideoId = null,
  newVideoIds,
}: {
  videos: MediaContent[];
  onVideoClick: (videoId: string, source: string, title: string) => void;
  selectedVideoId: string | null;
  newVideoIds: Set<string>;
}) => {
  const { isMobile } = useScreenSize();
  const renderVideo = (video: MediaContent) => {
    if (isMobile) {
      return (
        <VideoCard
          video={video}
          onClick={(videoId: string) => onVideoClick(videoId, video.source || 'youtube', video.title)}
          selected={video.id === selectedVideoId}
          isNew={newVideoIds.has(video.id)}
        />
      );
    }
    return (
      <CarouselCard
        title={video.title}
        imageUrl={video.thumbnail}
        onClick={() => onVideoClick(video.id, video.source || 'youtube', video.title)}
        duration={video.duration_seconds}
        publishedAt={video.published_at}
        variant={isMobile ? 'mobile' : 'desktop'}
        isSelected={selectedVideoId === video.id}
      />
    );
  };

  return <Carousel items={videos} renderItem={renderVideo} itemHeight={isMobile ? '235px' : '280px'} gap={16} />;
};
